import { create } from 'zustand'

interface ProductState {
  totalResult: number | undefined
  setTotalResult: (totalResult: number) => void
}

export const useProductStore = create<ProductState>((set) => ({
  totalResult: undefined,
  setTotalResult: (totalResult) => set({ totalResult }),
}))
